export default __webpack_public_path__ + "static/media/Size2.0d33c2a4.png";